import { aTrack } from '../primitives/a-track';
class TradeTabEvent {
    constructor() {
        this.options = {
            origin: 'trade_tab',
        };
    }
    clicked_trade_tab() {
        aTrack('clicked_trade_tab', this.options);
    }
    clicked_settings(current_slippage) {
        aTrack('clicked_settings', Object.assign({ current_slippage }, this.options));
    }
    changed_slippage_tolerance(previous_slippage, new_slippage) {
        aTrack('changed_slippage_tolerance', Object.assign({ previous_slippage,
            new_slippage }, this.options));
    }
    opened_token_selector(position, token) {
        aTrack('opened_token_selector', Object.assign({ position, token }, this.options));
    }
    selected_token(position, previous_token, new_token) {
        aTrack('selected_token', Object.assign({ position,
            previous_token,
            new_token }, this.options));
    }
    clicked_max_token(token, amount) {
        aTrack('clicked_max_token', Object.assign({ token, amount }, this.options));
    }
    entered_amount_token(token, amount) {
        aTrack('entered_amount_token', Object.assign({ token, amount }, this.options), { isDebounced: true });
    }
    switched_trade_tokens(token_pair) {
        aTrack('switched_trade_tokens', Object.assign({ token_pair }, this.options));
    }
    clicked_preview_trade(token_in, token_out, amount_in, dollar_value, slippage) {
        aTrack('clicked_preview_trade', Object.assign({ token_in,
            token_out,
            amount_in,
            dollar_value,
            slippage }, this.options));
    }
    clicked_confirm_trade(token_in, token_out, amount_in, expected_out, minimum_out, dollar_value, slippage) {
        aTrack('clicked_confirm_trade', Object.assign({ token_in,
            token_out,
            amount_in,
            expected_out,
            minimum_out,
            dollar_value,
            slippage }, this.options));
    }
}
export function createTradeTabEvent() {
    return new TradeTabEvent();
}
//# sourceMappingURL=trade-tab.js.map